import React, { useState, useEffect } from 'react';
import { withFormik } from 'formik';
import Service from '../../../../../apiService';
import View from './View';
import useDataFetching from '../../../../hooks/useDataFetching';
import Alert from 'view/component/Alert';

const FormPenilaianRumahMakan = ({
  values,
  errors,
  data,
  setFieldValue,
  handleSubmit,
  backHome,
}) => {
  const { error, loading, results } = useDataFetching({
    url: '/department/penilaian/find/1',
    method: 'get',
  });

  const { results: penilaianResult } = useDataFetching({
    url: `/department/penilaian/result/${data.id}`,
    method: 'get',
  });

  const row = rowMapper(results.data || []);

  const handleChange = (e, maxValue) =>
    setFieldValue(e.target.name, {
      id: parseInt(e.target.name),
      value: parseInt(e.target.value || 0),
      maxValue: parseInt(maxValue),
    });

  return (
    <View
      row={row}
      values={values}
      errors={errors}
      penilaianResult={penilaianResult}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      data = {data}
    />
  );
};

export default withFormik({
  mapPropsToValues: (props) => ({}),
  validate: (values) => {
    const errors = {};

    Object.values(values).forEach((value) => {
      if (value.value > value.maxValue) errors[value.id] = 'Melebihi batas';
    });

    return errors;
  },
  handleSubmit: async (fieldValues, { props }) => {
    const user = JSON.parse(localStorage.getItem('userData'));
    console.log(user);

    const results = Object.values(fieldValues).map((value) => value);
    const finalValue = {
      registration_id: props.data.id,
      examiner_id: user.id,
      results: results,
    };
    const post = await Service.post('/department/penilaian/upload', finalValue);
    if (post.code === 200) Alert('success', 'Penilaian Berhasil');
  },
})(FormPenilaianRumahMakan);

//helper

function rowMapper(questions) {
  const row = [];
  questions.forEach((question) => {
    const data = question.sub.map((child) => ({ ...child }));
    row.push([question.name, data]);
  });

  return row;
}
